/**
 * @param {string} template
 * @returns {HTMLElement}
 */
export default function createTemplateElement(template) {
  let element = null;

  const div = document.createElement('div');

  // If createContextualFragment does not exist, fallback to catch
  try {
    element = document.createRange().createContextualFragment(template);
    div.appendChild(element);
  } catch (e) {
    div.innerHTML = template.trim();
  }

  return div.children[0];
}
